console.log("BUILD_TAG: routing-refactor-v1");

import React, {
  useEffect,
  useState,
  useCallback
} from "react";

import {
  BrowserRouter,
  useNavigate
} from "react-router-dom";

import axios from "axios";

import { connectSocketOnce } from "./socket";

import AppRoutes from "./routes/AppRoutes";

const API =
  process.env.REACT_APP_API_URL ||
  "https://vartasocial.com/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat(
    (4 - base64String.length % 4) % 4
  );

  const base64 = (base64String + padding)
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);

  const outputArray = new Uint8Array(
    rawData.length
  );

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

function AppInner() {

  const navigate = useNavigate();

  const [token, setToken] = useState(
    localStorage.getItem("token") || ""
  );

  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(
        localStorage.getItem("user") || "null"
      );
    } catch {
      return null;
    }
  });

  useEffect(() => {

  if (!token) return;

  // ✅ connect socket only AFTER auth exists
  connectSocketOnce();

  // ✅ push notifications
  if ("serviceWorker" in navigator) {

    navigator.serviceWorker
      .register("/sw.js")
      .then(async (reg) => {

        const permission =
          await Notification.requestPermission();

        if (permission !== "granted") return;

        const vapidKey =
          urlBase64ToUint8Array(
            process.env.REACT_APP_VAPID_PUBLIC_KEY
          );

        const sub =
          await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: vapidKey
          });

        await axios.post(
          `${API}/push/subscribe`,
          { subscription: sub },
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

      });

  }

}, [token]);

  const loadMe = useCallback(async () => {

    if (!token) return;

    try {

      const r = await axios.get(
        `${API}/me`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setUser(r.data.user);

      localStorage.setItem(
        "user",
        JSON.stringify(r.data.user)
      );

    } catch {

      setToken("");
      setUser(null);

      localStorage.clear();

      navigate("/login", {
        replace: true
      });

    }

  }, [token, navigate]);

  useEffect(() => {

    if (token) {
      loadMe();
    }

  }, [token, loadMe]);

  return (
    <AppRoutes
      token={token}
      setToken={setToken}
    />
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}